import dayjs from 'dayjs';
import {Link} from 'react-router-dom';

import {TIME_FORMATS} from '@/utils/timeFormats';

const Copyright = () => {
  const buildDate = __APP_BUILD_DATE__;
  const buildNumber = __APP_BUILD_NUMBER__;
  const formattedBuildDate = dayjs(buildDate).format(TIME_FORMATS.dateTime);

  return (
    <div className="flex flex-wrap items-center justify-center gap-2 px-2 py-3 text-center">
      <p className="type-body2 text-neutral-300">
        Copyright © <a href="https://nursiolink.com">nursiolink.com</a>{' '}
        {new Date().getFullYear()}
      </p>
      <p className="type-body2 text-neutral-300">
        <Link className="underline-offset-2 hover:underline" to="/releases">
          (v{formattedBuildDate}, build {buildNumber})
        </Link>
      </p>
    </div>
  );
};

export default Copyright;
